<template>
  <div>
      <alert />
      <form-group />
  </div>
</template>
<script>
import FormGroup from './components/form.vue'
import Alert from './components/alert.vue'
export default {
  components: { FormGroup, Alert }
}
</script>
